export const normalizePaidOrderIds = (orderIds = []) =>
  new Set(
    (Array.isArray(orderIds) ? orderIds : [orderIds])
      .map((value) => Number(value))
      .filter((value) => Number.isInteger(value) && value > 0),
  );

export const shouldInvalidateRecentPaymentGuard = (guard, event = {}) => {
  if (!guard) return false;
  const eventOrderId = Number(event?.orderId);
  if (!Number.isInteger(eventOrderId) || eventOrderId <= 0) return true;
  return !guard.paidOrderIds?.has(eventOrderId);
};

export const isItemFromPaidOrder = (item, guard) => {
  if (!guard?.paidOrderIds) return false;
  const orderId = Number(item?.order_id ?? item?.orderId);
  return Number.isInteger(orderId) && guard.paidOrderIds.has(orderId);
};
